<div class="container">
  <button
    *ngIf="!submit"
    class="button"
    [ngClass]="classesApplied"
    [disabled]="disabled"
    (click)="onClick($event)"
  >
    {{ label | translate }}
    <div *ngIf="iconShow" class="button-icon">
      <img [src]="getIcon" alt="" />
    </div>
  </button>

  <button
    *ngIf="submit"
    type="submit"
    class="button"
    [ngClass]="classesApplied"
    [disabled]="disabled"
    (click)="onClick($event)"
  >
    {{ label | translate }}
    <div *ngIf="iconShow" class="button-icon">
      <img [src]="getIcon" alt="" />
    </div>
  </button>
</div>
